///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import addTitleForTruncatedText from "../../../helpers/addTitleForTruncatedText";
import tableSelection from "../../../helpers/tableSelection";

export const SimpleCell = ({
  value,
  cellDetails: {
    right,
    format,
    cellUnit,
    unitLeft,
    formatCurrency,
    center,
    style: getStyle
  },
  children,
  rowIndex,
  cellIndex,
  isLaneMatch,
  disabled,
  userDivision,
  bidDivision,
  analyticsGridView,
  lane,
  role
}) => {
  let formattedValue = format ? format(value, userDivision) : value;
  let unit = formatCurrency ? formatCurrency(value, bidDivision) : cellUnit;
  if (
    (formattedValue || formattedValue === 0) &&
    unit &&
    !isNaN(formattedValue)
  ) {
    formattedValue = parseFloat(formattedValue);
    formattedValue = (Math.round(formattedValue * 100) / 100).toFixed(2);
  }
  if ((formattedValue || formattedValue === 0) && unit) {
    formattedValue = unitLeft ? unit + formattedValue : formattedValue + unit;
  }

  return (
    <td
      className={`simple-cell ${disabled ? "disabled" : ""} ${
        right ? "text-right" : ""
      } ${center ? "text-center" : ""}`}
      onMouseLeave={e => (e.target.title = "")}
      onMouseDown={e =>
        tableSelection.onMouseDown(
          e,
          rowIndex,
          cellIndex,
          isLaneMatch,
          analyticsGridView
        )
      }
      onMouseEnter={e => {
        addTitleForTruncatedText(e.target, formattedValue);
        tableSelection.onMouseEnter(
          e,
          rowIndex,
          cellIndex,
          isLaneMatch,
          analyticsGridView
        );
      }}
      onClick={e =>
        tableSelection.handleClick(
          e,
          rowIndex,
          cellIndex,
          isLaneMatch,
          analyticsGridView
        )
      }
      style={getStyle && getStyle(lane, role)}
    >
      {formattedValue || formattedValue === 0 ? formattedValue : children}
    </td>
  );
};

export default SimpleCell;
